module.exports = __webpack_public_path__ + "media/images/channel_megamenu_promo-d71bdcb96a2ee91560d126fd69993145.png";